import { CONFIG_NAME } from "../config/loadShellEnv";

export const ENV =
  (CONFIG_NAME?.split(".")[1] as
    | "prod"
    | "qa"
    | "stg"
    | "dev"
    | "local"
    | "unknown") ?? "unknown";

export const ENTRY = CONFIG_NAME.split(".")[0] as "mm" | "engage" | "cop";
